import request from "@/utils/request";

// 分页查询
export function queryAllotTable(data) {
  return request({
    url: "/allocate/table",
    method: "post",
    data,
  });
}
// 获取调拨管理列表
export function queryAllotTableNew(data) {
  return request({
    url: "/allocate/page",
    method: "get",
    params: data,
  });
}

// 新增调拨
export function insertAllot(data) {
  return request({
    url: "/allocate/insert",
    method: "post",
    data,
  });
}
// 新增调拨管理数据
export function insertAllotNew(data) {
  return request({
    url: "/allocate/save",
    method: "post",
    data,
  });
}

// 新增调拨管理数据
export function updateAllotNew(data) {
  return request({
    url: "/allocate/update",
    method: "post",
    data,
  });
}

// 通过id查询详情
export function queryAllotById(id) {
  return request({
    url: `/allocate/info/${id}`,
    method: "get",
  });
}
export function queryAllotByIdNew(id) {
  return request({
    url: `/allocate/${id}`,
    method: "get",
  });
}

// 通过审批id查询详情
export function queryAllotDetailByApprovalId(id) {
  return request({
    url: `/allocate/getAllocateByApprovalId/${id}`,
    method: "get",
  });
}

// 提交审核
export function handleProcessApi(id) {
  return request({
    url: "/approval/submitAuditingV164/" + id,
    method: "put",
  });
}

// 删除调拨列表
export function deleteCheckById(id) {
  return request({
    url: `/allocate/delete/` + id,
    method: "delete",
  });
}

